/* Mission Beard — Beard Gifts collection page.
   1. Price filter strip: shows/hides grid cards by data-band, no reload.
      ?filter=low|mid|high preselects a band (used by the "Or: brush and comb sets" link).
   2. Scent matcher: one scent selected at a time. Desktop fills the result panel;
      below 1100px the answer opens inline under the tapped button (CSS decides which shows).
   Every card and every scent answer is in the DOM on load; nothing is injected. */
(function () {
  'use strict';
  if (window.__mbGiftsInit) return;
  window.__mbGiftsInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Filter strip */
    document.querySelectorAll('[data-mb-gifts-grid]').forEach(function (grid) {
      var buttons = grid.querySelectorAll('[data-mb-gifts-filter]');
      var cards = grid.querySelectorAll('[data-band]');
      var count = grid.querySelector('[data-mb-gifts-count]');
      var total = cards.length;

      function apply(band) {
        var shown = 0;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mb-gifts-filter') === band ? 'true' : 'false'); });
        cards.forEach(function (c) {
          var on = band === 'all' || c.getAttribute('data-band') === band;
          c.hidden = !on;
          if (on) shown++;
        });
        if (count) count.textContent = band === 'all' ? count.getAttribute('data-all') : shown + ' of ' + total + ' gifts';
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-mb-gifts-filter')); });
      });

      var preset = new URLSearchParams(window.location.search).get('filter');
      if (preset && grid.querySelector('[data-mb-gifts-filter="' + preset + '"]')) apply(preset);

      // In-page links like "?filter=low#grid" filter and scroll without a reload.
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="?filter="]');
        if (!a) return;
        var band = new URLSearchParams(a.getAttribute('href').split('#')[0]).get('filter');
        if (!grid.querySelector('[data-mb-gifts-filter="' + band + '"]')) return;
        e.preventDefault();
        apply(band);
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Scent matcher */
    document.querySelectorAll('[data-mb-gifts-scents]').forEach(function (sec) {
      var items = sec.querySelectorAll('[data-scent]');
      var panel = sec.querySelector('[data-mb-gifts-panel]');

      function select(item) {
        items.forEach(function (it) {
          var on = it === item;
          it.classList.toggle('is-open', on);
          it.querySelector('[data-mb-gifts-scent-btn]').setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        if (!panel) return;
        var d = item.dataset;
        panel.style.setProperty('--scent', d.color);
        var img = panel.querySelector('img');
        if (img) {
          img.src = d.img;
          img.removeAttribute('srcset');
          img.alt = d.alt;
        }
        panel.querySelector('[data-p-get]').textContent = d.get;
        var name = panel.querySelector('[data-p-name]');
        name.textContent = d.name;
        name.href = d.url;
        panel.querySelector('[data-p-smells]').textContent = d.smells;
        var shop = panel.querySelector('[data-p-shop]');
        shop.textContent = d.shop;
        shop.href = d.url;
      }

      items.forEach(function (item) {
        item.querySelector('[data-mb-gifts-scent-btn]').addEventListener('click', function () { select(item); });
      });
    });
  });
})();
